module.exports = __webpack_public_path__ + "static/media/test9_3.5e0d749b.png";